module.exports = __webpack_public_path__ + "static/media/  (168).11190511.jpg";